import { buildURL, callAPI, Urls } from "helpers/apiUrls";
import { cacheManager, getUserInfo, getUUIDNumberFromLocalStorage, decryptTokens } from "helpers/utilCommon";
import { appConfig } from "helpers/appConfig";
import { setMiniAppLoader } from "redux/app/actions";
import { setMessage } from "redux/shared/actions";
import { setUserInfo } from '../redux/login/actions';
import lodash from "lodash";
import axios from 'axios';

export const checkUser = () => {
    return dispatch => {
        const userInfo = getUserInfo();
        dispatch(setUserInfo(userInfo));
    }
}

export const flagFeature = (callback, isHideLoader = false) => {
    return (dispatch) => {
        if (!isHideLoader) {
            dispatch(setMiniAppLoader(true));
        }
        const url = buildURL(Urls.flagFeature, null, null, true);
        callAPI(url, 'get', null, true, (response) => {
            if (response && response.Status) {
                cacheManager.setItem('flagFeature', response.Result);
                callback(response.Result);
            } else {
                const uuidNumber = getUUIDNumberFromLocalStorage(url);
                dispatch(setMessage(true, '4003', uuidNumber));
                callback(null);
            }
            if (!isHideLoader) {
                dispatch(setMiniAppLoader(false));
            }
        });
    }
}

export const flagFeatureForDMS = (callback, dispatch, isHideLoader = false) => {
        if (!isHideLoader) {
            dispatch(setMiniAppLoader(true));
        }
        const url = buildURL(Urls.flagFeature, null, null, true);
        callAPI(url, 'get', null, true, (response) => {
            if (response && response.Status) {
                callback(response.Result);
            } else {
                const uuidNumber = getUUIDNumberFromLocalStorage(url);
                dispatch(setMessage(true, '4003', uuidNumber));
                callback(null);
            }
            if (!isHideLoader) {
                dispatch(setMiniAppLoader(false));
            }
        });
}

export const bannerFeatureAction = (callback) => {
    const url = buildURL(Urls.bannerFeature, null, null);
    callAPI(url, 'get', null, true, (response) => {
        if (response && response.status) {
            callback(response.content);
        } else {
            callback(null);
        }
    });
}

export const clearRedis = (cb) => {
    const url = `${buildURL(Urls.clearRedis, null, null)}`;
    callAPI(url, 'get', null, false, () => {
        cb();
    });
}

export const getAuthKeys = (dispatch, callback) => {
    const url = buildURL(Urls.getAuthKeys, null, null);
    const headers = {};
    headers['s-origin'] = window.location.origin;
    dispatch(setMiniAppLoader(true));
    axios.get(url, { headers })
        .then((response) => {
            if (response?.data?.status) {
                appConfig.setEncryptionKey(
                    decryptTokens(response?.data?.content?.APP_ENCRYPTION_KEY, response?.data?.content?.ENCRYPT_KEY));
                appConfig.setDatadogClientToken(
                    decryptTokens(response?.data?.content?.REACT_APP_DATADOG_CLIENT_TOKEN, response?.data?.content?.ENCRYPT_KEY));
                appConfig.setReactAppOpenSecurityKey(
                    decryptTokens(response?.data?.content?.REACT_APP_OPEN_SECURITY_KEY, response?.data?.content?.ENCRYPT_KEY));
                appConfig.setReactAppSecretKey(
                    decryptTokens(response?.data?.content?.REACT_APP_SECRET_KEY, response?.data?.content?.ENCRYPT_KEY));
                dispatch(setMiniAppLoader(false));
                callback(true, lodash.get(response.data, 'message'), response.data.content);
            } else {
                dispatch(setMiniAppLoader(false));
                callback(false, '1012', null);
            }
        });
};

export default {
    checkUser,
    flagFeature,
    flagFeatureForDMS,
    bannerFeatureAction,
    clearRedis,
    getAuthKeys
}